// /league/racecard/ で使用
// SP時の出走表、レース結果エリアの横スクロールバー表示

export default () => {

  const r = {};
  const init = () => {
    const isPc = window.matchMedia('(min-width: 769px').matches;
    r.roots = document.querySelectorAll('.js-flick-area');
    if (!r.roots.length || isPc) {
      return;
    }
    buildScrollBars();
  }

  const buildScrollBars = () => {
    r.roots.forEach(scopeRoot => {
      buildScrollBar(scopeRoot);
    })
  }
  const buildScrollBar = (root) => {
    console.log(root)
    const scrollArea = root.querySelector('[class*="__table-inner"]');

    const rail = root.querySelector('.le-round-scrollbar__rail');
    const thumb = root.querySelector('.le-round-scrollbar__thumb');
    scrollArea.addEventListener('scroll', (evt) => {
      const rate = evt.target.scrollLeft / (evt.target.scrollWidth - scrollArea.clientWidth)
      const setTranslateX = (rail.clientWidth - thumb.clientWidth) * rate
      thumb.style.transform = `translateX(${setTranslateX}px)`
    })

  }

  init();

  return {}
}
